/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TractorBeamGameAssets} from "../TractorBeamGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IBoxConfig, SpritePageFlipper} from "./pageFlipper/SpritePageFlipper";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";

export class TractorBeamIntroView extends StillImageBgIntroView {

    //private _text:PIXI.Text;
    private _logo:PIXI.Sprite;
    private _gfxContainer:PIXI.Container;

    private _pageFlipView:SpritePageFlipper;
    private _pageBoxConfig:IBoxConfig [] = [];

    constructor(config:IStillImageBgIntroViewConfig) {
        super(config);
    }

    protected startPresentation(data?: ParsedServerData, onShowComplete?: () => void):void {
        super.startPresentation(data, onShowComplete);

        this._pageFlipView.startSlideShow(7);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._gfxContainer = new PIXI.Container();
        this._logo = new PIXI.Sprite(GameResources.getTextures(TractorBeamGameAssets.INTRO_LOGO)[0]);
        this._logo.anchor.set(0.5, 0);

        //this._text = new PIXI.Text("", {fill : 0xffffff, fontSize : 80});
        //this._text.anchor.set(0.5, 0);


        //this._gfxContainer.addChild(this._text);

        const arrowUp:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("arrowUp")[0]);
        const arrowDown:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("arrowDown")[0]);

        this._pageBoxConfig =  [
            {
                backgroundTexture: GameResources.getTextures("infoBg")[0],
                infoSprite: new PIXI.Sprite(GameResources.getTextures("page1")[0]),
                //title: "Beam 'Em Up!",
                text: Translation.translate("All non-organic symbols will be beamed off the reels.")
            },
            {
                //title: "Clone Attack!",
                infoSprite: new PIXI.Sprite(GameResources.getTextures("page2")[0]),
                text: Translation.translate("Expect one animal to be beamed back in on the reels - in stacks!")
            },
            {
                //title: "Abduction Spins!",
                infoSprite: new PIXI.Sprite(GameResources.getTextures("page3")[0]),
                text: Translation.translate("All winning symbols will be abducted - until only Wilds exists on the reels!")
            }
        ];
        this._pageFlipView = new SpritePageFlipper(
            arrowUp,
            arrowDown,
            this._pageBoxConfig
        );
        this._pageFlipView.forceInitAnimations();
        this._pageFlipView.interactEnabled = true;
        this._gfxContainer.addChild(this._pageFlipView);
        this._gfxContainer.addChild(this._logo);
        this._pageFlipView.slideShowEnabled = true;


        return this._gfxContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {

        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._gfxContainer.position.set(GameConfig.instance.GAME_WIDTH / 2, 0);
            this._logo.y = -300;
            this._logo.scale.set(1.6);
            (<PIXI.Sprite> this._background).y = this._screenHeight * 0.5;

            this._pageFlipView.scale.set(1.95, 1.95);
            this._pageFlipView.position.set(-400, /*featureY*/ 50);

            this._gfxContainer.position.set(GameConfig.instance.GAME_WIDTH / 2, this._screenHeight * 0.3);
            this._logo.position.x = this._screenWidth * 0.5 - this._gfxContainer.position.x;
        }
        else {
            this._logo.scale.set(0.6);
            this._logo.y = -60;
            (<PIXI.Sprite> this._background).y = 450;

            this._pageFlipView.scale.set(1.2, 1.2);
            this._pageFlipView.position.set(-195, /*featureY*/ 30);

            this._gfxContainer.position.set(GameConfig.instance.GAME_WIDTH / 2, this._screenHeight * 0.1);
            this._logo.position.x = this._screenWidth * 0.5 - this._gfxContainer.position.x;
        }

        this._pageFlipView.setOrientationSetting(resizeData.orientation);

    }
}
